import { WorkspaceConnectSettingDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { IFiltrableItemQueryDto } from '@common-modules/shared/model/filtrable-items/filtrable-item-query.dto';
import { IFiltrableItemDto } from '@common-modules/shared/model/filtrable-items/filtrable-item.dto';
import { FiltrableItemTypeEnum } from '@common-modules/shared/model/filtrable-items/types/filtrable-item-type-enum';
import { IFiltrableType } from '@common-modules/shared/model/filtrable-items/types/filtrable-type';

export class CTResultFiltrableItemDto implements ICTResultFiltrableItemDto {
  startDate: Date;
  endDate: Date;
  filtrableType: ICTResultFiltrableType;
}

export interface ICTResultFiltrableItemDto extends IFiltrableItemDto {}

export interface ICTResultFiltrableType extends IFiltrableType {
  workspaceConnectSetting: WorkspaceConnectSettingDto;
  networkElementTypeId: string;
  networkElementId: string;
  attributeId: string;
  networkElementName: string;
  subtitle: string;
}

export class CTResultFiltrableType implements ICTResultFiltrableType {
  key: string;
  title: string;
  subtitle: string;
  workspaceConnectSetting: WorkspaceConnectSettingDto;
  networkElementTypeId: string;
  networkElementId: string;
  attributeId: string;
  networkElementName: string;
  units?: string;
  physType?: string;

  type: FiltrableItemTypeEnum = FiltrableItemTypeEnum.CTResult;

  constructor(init: Partial<CTResultFiltrableType>) {
    this.key = `${init.networkElementId}-${init.attributeId}-${init.workspaceConnectSetting.scenarioId}`;
    Object.assign(this, init);
  }
}

export class CTResultFiltrableItemQueryDto implements IFiltrableItemQueryDto {
  startDate: Date;
  endDate: Date;
  apiEndpoint: string;
  extraParams: any;

  constructor(
    startDate: Date,
    endDate: Date,
    apiEndpoint: string,
    networkElementId: string,
    attributeId: string,
    scenarioId: string
  ) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.apiEndpoint = apiEndpoint;

    this.extraParams = {
      networkElementId,
      attributeId,
      scenarioId,
    };
  }
}

export class CTAttributeResult {
  scenarioId: string;
  networkElementId: string;
  networkElementName: string;
  attributeName: string;
  values: { [dateStr: string]: string };
  unitLabel: string;

  constructor(init: Partial<CTAttributeResult>) {
    Object.assign(this, init);
  }
}
